import { http } from "../api/http";
import Utils from "../utils";

export const runbookServerService = {
  getAll,
  get,
  getById,
  create,
  update,
  remove,
};

function getAll() {
  let url = "/runbookserver/getall";

  // #2583: only used to populate a server-picker dropdown (RunbookForm, EditRunbookModal) —
  // a 401 here means the caller lacks access to this particular list, not that their session
  // is dead, so it shouldn't force a logout. See the skipAuthRedirect comment in api/http.js.
  return http.get(url, { skipAuthRedirect: true }).then((response) => {
    return response;
  });
}

function get(requestParameters) {
  let url = `/runbookserver?${Utils.objectToQueryString(requestParameters)}`;

  return http.get(url).then((response) => {
    return response;
  });
}

function getById(requestParameters) {
  let url = `/runbookserver/byid?${Utils.objectToQueryString(requestParameters)}`;

  return http.get(url).then((response) => {
    return response;
  });
}

function create(requestBody) {
  let url = `/runbookserver/create`;

  return http.post(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

function update(requestBody) {
  let url = `/runbookserver/update`;

  return http.put(url, JSON.stringify(requestBody)).then((response) => {
    return response;
  });
}

function remove(requestParameters) {
  let url = `/runbookserver/delete?${Utils.objectToQueryString(requestParameters)}`;

  return http.delete(url).then(
    (response) => {
      return response;
    },
    (error) => {
      throw error;
    }
  );
}
